import { render, staticRenderFns } from "./CampoBuscarFornecedor.vue?vue&type=template&id=091a4bba&scoped=true&"
import script from "./CampoBuscarFornecedor.vue?vue&type=script&lang=js&"
export * from "./CampoBuscarFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091a4bba",
  null
  
)

export default component.exports